const GetCurrencyLookupData = "Currency/GetAllCurrencyLookupData"
const CreateCurrencyLookupData = "Currency/CreateCurrencyLookupData"
const UpdateCurrecyLookupData = "Currency/UpdateCurrecyLookupData"
const GetAllCurrencyLookupHistory = "Currency/GetAllCurrencyLookupHistory"
const GetDialyExchangeData = "Currency/GetDailyExchangeData"
const UpdateCurrencyLookupStatus = "Currency/UpdateCurrencyLookupStatus"
const FilterApprovalData = "Approval/FilterApprovalData"

const GetAllCompanyCurrencyList = "CompanyMapping/GetAllCompanyCurrencyList"
const UpdateCurrencyCurrencyMappingStatus = "CompanyMapping/UpdateCurrencyCurrencyMappingStatus"
const GetAllCompanyCurrencyHistory = "CompanyMapping/GetAllCompanyCurrencyHistory"
const GetAgentDetails = "Company/GetAgentDetails"
const GetVesselDetails = "Company/GetVesselDetails"
const GetCompanyMappingDataByAgent = "CompanyMapping/GetCompanyMappingDataByAgenId"
const AddOrUpdateCompayMappingData = "CompanyMapping/AddOrUpdateCompayMappingData"
const DownloadFile = "CompanyMapping/DownloadFile"
const UpdateProductPriceStatus = "Product/UpdateProductPriceStatus"
const GetAllProductHistoryData = "Product/GetAllProductHistoryData"
const GetAllProductPrices = "Product/GetAllProductPrices"
const UpdateProductCodePriceData = "Product/UpdateProductCodePriceData"
const GetAllProductCodes = "Product/GetAllProductCodes"
const GetUsers = 'UserManagement/GetUsers'
const GetUserRoles = 'UserManagement/GetUserRoles'
const SaveUserRoles = 'UserManagement/SaveUserRoles'
const GetAllRoles = "UserManagement/GetAllRoles"
const GetUserByEmail = "/User/GetUserDetails"
const CreateUser = "/User/CreateUser"
const GetAllMGUsers = "/User/GetAllMGUsers"
const PreviewADMDocument = "ADM/PreviewADMDocument"
const GetADMRevisions = "ADM/GetADMRevisions"
const GenerateADMDocument = "ADM/GenerateADMDocument"

const UpdateProductCodeMapping = "Product/UpdateProductCodeMapping"
const ADMDownloadFile = "ADM/DownloadFile"

const GetAgentDetailsByDocumentId = "Invoice/GetAgentDetailsByDocumentId"
const GetInvoiceDocument = "Invoice/GetInvoiceDocument"
const GetDocumentStatus = "Invoice/GetDocumentStatus"
const GetSalesTransactionWorkDetails = "Invoice/GetSalesTransactionWorkDetails"
const GetSalesTransactionHistoryDetails = "Invoice/GetSalesTransactionHistoryDetails"
const GetDocumentWorkDistributionDetails = "Invoice/GetDocumentWorkDistributionDetails"
const GetDocumentHistoryDistributionDetails = "Invoice/GetDocumentHistoryDistributionDetails"
const GetPaymentDetails = "Invoice/GetPaymentDetails"

const GetAllDiscountsData = "AgentDiscount/GetAllDiscounts"
const CreateDiscount = "AgentDiscount/CreateDiscountData"
const UpdateDiscountLookUpStatus = "AgentDiscount/UpdateDiscountLookUpStatus"
const UpdateDiscountLookupId = "AgentDiscount/UpdateAgentDiscounts"
const GetAllApprovalDiscounts = "AgentDiscount/GetAllApprovalDiscounts"
const GetAllExpiredDiscounts = "AgentDiscount/GetAllExpiredDiscounts"
const ValidateAgentDiscount = "AgentDiscount/ValidateAgentDiscount"
const GetAllDiscountApprovals  = "AgentDiscount/GetAllDiscountApprovals"

const GetAllVesselDiscounts = "VesselDiscount/GetAllVesselDiscounts"
const GetAllExpiredVesselDiscounts = "VesselDiscount/GetAllExpiredVesselDiscounts"
const GetAllVesselDiscountApprovals  = "VesselDiscount/GetAllVesselDiscountApprovals"
const UpdateVDiscountLookupId = "VesselDiscount/UpdateVesselDiscounts"
const CreateVDiscount = "VesselDiscount/CreateVesselDiscountData"
const ValidateVesselDiscount = "VesselDiscount/ValidateVesselDiscountCreation"
const UpdateVDiscountLookUpStatus = "VesselDiscount/UpdateDiscountLookUpStatus"

export const ApiUrls = {
    CreateCurrencyLookupData,
    GetInvoiceDocument,
    GetCurrencyLookupData,
    UpdateCurrecyLookupData,
    GetAllCurrencyLookupHistory,
    GetDialyExchangeData,
    FilterApprovalData,
    UpdateCurrencyLookupStatus,
    GetAllCompanyCurrencyList,
    UpdateCurrencyCurrencyMappingStatus,
    GetAllCompanyCurrencyHistory,
    GetAgentDetails,
    GetVesselDetails,
    GetCompanyMappingDataByAgent,
    AddOrUpdateCompayMappingData,
    DownloadFile,
    UpdateProductPriceStatus,
    GetAllProductHistoryData,
    GetAllProductPrices,
    UpdateProductCodePriceData,
    GetAllProductCodes,
    GetUsers,
    GetUserRoles,
    SaveUserRoles,
    GetAllRoles,
    GetUserByEmail,
    CreateUser,
    GetAllMGUsers,
    UpdateProductCodeMapping,
    PreviewADMDocument,
    GetADMRevisions,
    GenerateADMDocument,
    ADMDownloadFile,

    GetAgentDetailsByDocumentId,
    GetDocumentStatus,
    GetSalesTransactionWorkDetails,
    GetSalesTransactionHistoryDetails,
    GetDocumentWorkDistributionDetails,
    GetDocumentHistoryDistributionDetails,
    GetPaymentDetails,

    GetAllDiscountsData,
    GetAllVesselDiscounts,
    CreateDiscount,
    CreateVDiscount,
    UpdateDiscountLookUpStatus,
    UpdateDiscountLookupId,
    UpdateVDiscountLookupId,
    GetAllApprovalDiscounts,
    GetAllExpiredDiscounts,
    GetAllExpiredVesselDiscounts,
    ValidateAgentDiscount,
    ValidateVesselDiscount,
    UpdateVDiscountLookUpStatus,
    GetAllDiscountApprovals,
    GetAllVesselDiscountApprovals
}